import { graphql } from '@predium/client-graphql';

graphql(`
  fragment GetSessionDataOrg on org {
    id
    name
    status_type_id
    org_type_id
    org_sector_type_id
    logo {
      id
      downloadUrl
    }
  }
`);

export const GET_SESSION_DATA = graphql(`
  query GetSessionData {
    getSessionData(args: {}) {
      user {
        id
        email
        firstName
        lastName
        createdAt
        role: userRole
        language
        roleDescription
        isActive
      }
      org {
        id
        logoUrl
        name
        orgSector: orgSectorTypeId
        orgTypeId
        statusTypeId
        userLogoutIdleTimeout
        isEconomicUnitsToggled
      }
      enabledFeatureFlags
      isAdmin
      firstBuildingId
      hasPortfolioWithWriteAccess
    }
  }
`);

export const GET_USERS = graphql(`
  query GetAllUsers {
    user {
      id
      first_name
      last_name
      email
      created_at
      role_id
    }
  }
`);

export const GET_USER_BY_ID = graphql(`
  query GetUserById($userId: Int!) {
    user_by_pk(id: $userId) {
      id
      first_name
      last_name
      email
      role_description
      created_at
      role_id
      org {
        id
      }
    }
  }
`);

export const GET_USER_OBJECTS_AGGREGATE = graphql(`
  query GetAllUserObjectsAggregate($userId: Int!) {
    report_aggregate(where: { responsible_user_id: { _eq: $userId } }) {
      aggregate {
        count
      }
    }

    scenario_aggregate(where: { owner_id: { _eq: $userId } }) {
      aggregate {
        count
      }
    }

    building_aggregate(where: { responsible_user_id: { _eq: $userId } }) {
      aggregate {
        count
      }
    }

    building_draft_aggregate(where: { responsible_user_id: { _eq: $userId } }) {
      aggregate {
        count
      }
    }

    energy_certificate_draft_aggregate(where: { responsible_user_id: { _eq: $userId } }) {
      aggregate {
        count
      }
    }
    active_action_plans_aggregate(where: { scenario: { owner_id: { _eq: $userId } } }) {
      aggregate {
        count
      }
    }
    action_aggregate(where: { action_plan: { active_scenario: { scenario: { owner_id: { _eq: $userId } } } } }) {
      aggregate {
        count
      }
    }

    consumption_aggregate(where: { created_by_user_id: { _eq: $userId } }) {
      aggregate {
        count
      }
    }

    consumption_draft_aggregate(where: { created_by_user_id: { _eq: $userId } }) {
      aggregate {
        count
      }
    }
  }
`);

/**
 * Queries all relevant notifications of a user that are specific to him, his organization or generally.
 * Results are ordered by recent notifications first.
 */
export const GET_NOTIFICATIONS = graphql(`
  query GetNotifications($user_id: Int!) {
    notification(where: { user_id: { _eq: $user_id } }, order_by: { created_at: desc }) {
      id
      __typename
      notification_template {
        id
        __typename
        title
        description
        href
      }
      read
      created_at
    }
  }
`);

export const GET_CURRENT_FEATURE_FLAGS = graphql(`
  query GetCurrentFeatureFlags {
    getUserFeatureFlags
  }
`);

export const GET_USER_LOGIN_HISTORY = graphql(`
  query GetUserLoginHistory($user_id: Int!, $limit: Int!, $offset: Int!) {
    getUserLoginHistory(user_id: $user_id, limit: $limit, offset: $offset) {
      events {
        date
        ip
        locationInfo {
          city
          country
        }
        userAgent
        clientName
      }
      lastLogin
      lastIp
      loginsCount
    }
  }
`);

export const GET_USERS_LIST_WITH_FULLNAME = graphql(`
  query GetUsersListWithFullname {
    user(order_by: { first_name: asc }) {
      id
      first_name
      last_name
    }
  }
`);
